import { useCallback, useRef, useState } from "react";
import { toId } from "../../types/treeNode.js";
const useTreeSearch = ({ tree, treeDomId, onSearchResult, onSelect })=>{
    const searchTimeoutRef = useRef();
    const [searchTerm, setSearchTerm] = useState("");
    const [resultSelectedNodeIdx, setResultSelectedNodeIdx] = useState();
    const [resultTreeBusy, setResultTreeBusy] = useState(false);
    const [resultTree, setResultTree] = useState();
    const applySearch = useCallback((rawTerm)=>{
        const searchValue = rawTerm.toLowerCase();
        const filterTerm = searchValue.trim();
        clearTimeout(searchTimeoutRef.current);
        if (filterTerm) {
            setSearchTerm(searchValue);
            setResultTreeBusy(true);
            setResultSelectedNodeIdx(undefined);
            searchTimeoutRef.current = setTimeout(()=>{
                const matches = [];
                const filter = (node)=>{
                    node.title.toLowerCase().includes(filterTerm) && matches.push(node);
                    node.childNodes?.forEach(filter);
                };
                tree.forEach(filter);
                const sliced = matches.slice(0, 19);
                setResultSelectedNodeIdx(-1);
                setResultTreeBusy(false);
                setResultTree(sliced);
                onSearchResult?.(sliced);
            }, 700);
            return;
        }
        setSearchTerm(searchValue);
        setResultSelectedNodeIdx(undefined);
        setResultTreeBusy(false);
        setResultTree(undefined);
        onSearchResult?.(undefined);
    }, [
        onSearchResult,
        tree
    ]);
    const handleSearchChange = useCallback((e)=>{
        applySearch(typeof e === "string" ? e : e.target.value);
    }, [
        applySearch
    ]);
    const handleSearchClose = useCallback(()=>applySearch(""), [
        applySearch
    ]);
    const handleSearchBlur = useCallback(()=>{
        setResultSelectedNodeIdx((current)=>typeof current === "number" ? -1 : undefined);
    }, []);
    const handleSearchKeyDown = useCallback((e)=>{
        if (typeof resultSelectedNodeIdx === "number" && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
            const addition = e.key === "ArrowDown" ? 1 : -1;
            setResultSelectedNodeIdx((current)=>typeof current === "number" ? current + addition : current);
            e.preventDefault();
            return false;
        }
        if (e.key === "Enter" && onSelect) {
            const searchSelected = document.getElementById(treeDomId)?.querySelectorAll(".aiot-search-selected");
            if (searchSelected?.length) {
                const { id } = searchSelected[0].dataset;
                id && onSelect(toId(id));
            }
            e.preventDefault();
            return false;
        }
        if (e.key === "Escape") {
            applySearch("");
            e.preventDefault();
            return false;
        }
        return true;
    }, [
        applySearch,
        onSelect,
        resultSelectedNodeIdx,
        treeDomId
    ]);
    return {
        searchTerm,
        resultSelectedNodeIdx,
        resultTreeBusy,
        resultTree,
        handleSearchChange,
        handleSearchClose,
        handleSearchBlur,
        handleSearchKeyDown
    };
};
export { useTreeSearch };
